module.exports = __webpack_public_path__ + "static/medical-2e534e6dd2c9f3918d01d1babe0f2c7b.jpg";